class CommercialFileEnergyEtatEnum {

    static readonly PROSPECT = new CommercialFileEnergyEtatEnum('PROSPECT', 'PROSPECT', 'prospect_badge',  '#888888');
    static readonly CLIENT  = new CommercialFileEnergyEtatEnum('CLIENT', 'CLIENT', 'client_badge',  '#888888');
    static readonly CLIENT_EN_ACQUISITION = new CommercialFileEnergyEtatEnum('CLIENT_EN_ACQUISITION', 'client_en_acquisition', 'CLIENT_EN_ACQUISITION_badge',  '#888888');
    //Client à fidéliser.
    static readonly CLIENT_A_FIDELISER = new CommercialFileEnergyEtatEnum('CLIENT_A_FIDELISER', 'Client à fidéliser', 'CLIENT_A_FIDELISER_badge',  '#7266ba');
    static readonly CLIENT_ACQUIS = new CommercialFileEnergyEtatEnum('CLIENT_ACQUIS', 'CLIENT_ACQUIS', 'client_acquis_badge',  '#888888');
    // Etape de validation de la boucle fidélisation (Qualité / BO / Responsable / Super admin).
    static readonly VALIDATION = new CommercialFileEnergyEtatEnum('VALIDATION', 'VALIDATION', 'VALIDATION_badge',  '#8cb04e');
    static readonly HORS_CIBLE = new CommercialFileEnergyEtatEnum('HORS_CIBLE', 'HORS_CIBLE', 'hors_cible_badge',  '#cc0000');

    private constructor(
        /**
         * The name of the instance; should be exactly the variable name,
         * for serializing/deserializing simplicity.
         */
        public readonly name: string,
        public readonly label: string,
        public readonly badge: string,
        public readonly color: string) {

        this.name = name;
        this.label = label;
        this.badge = badge;
        this.color = color;
    }

    static get values(): CommercialFileEnergyEtatEnum[] {
        return [
            this.PROSPECT,
            this.CLIENT,
            this.CLIENT_EN_ACQUISITION,
            this.CLIENT_ACQUIS,
            this.CLIENT_A_FIDELISER,
            this.VALIDATION,
            this.HORS_CIBLE
        ];
    }

    static getListLabes(): CommercialFileEnergyEtatEnum[] {
        return [
            this.PROSPECT,
            this.CLIENT,
            this.CLIENT_EN_ACQUISITION,
            this.CLIENT_ACQUIS,
            this.CLIENT_A_FIDELISER,
            this.VALIDATION,
            this.HORS_CIBLE
        ];
    }

    /**
     * Converts a string to its corresponding Status instance.
     *
     * @param string the string to convert to Status
     * @throws RangeError, if a string that has no corresponding Status value was passed.
     * @returns the matching Status
     */
    static fromString(string: string): CommercialFileEnergyEtatEnum {
        // Works assuming the name property of the status is identical to the variable's name.
        // Alternatively, you can search the .values array
        const value = (this as any)[string];
        if (value) {
            return value;
        }
        return null;
        //throw new RangeError(`Illegal argument passed to fromString(): $ {string} does not correspond to any instance of the enum ${(this as any).prototype.constructor.name}`);
    }


    /**
     * Called when converting the Enum value to a string using JSON.Stringify.
     * Compare to the fromString() method, which deserializes the object.
     */
    public getName(): string {
        return this.name;
    }

    public getLabel(): string {
        return this.label;
    }

    public getBadge(): string {
        return this.badge;
    }
}

export default CommercialFileEnergyEtatEnum;
